import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import { userTypeAtom } from '../auth/state';
import { useStopRecordingCallback } from '../provider/session-recording/useStopRecordingCallback';
import { UserType } from '../types';
import { AudioRecordingState } from '../video-sdk';

/**
 * A hook for centrally managing side-effects that should be triggered when the
 * user's session has expired and they need to re-login. These effects
 * currently include:
 *
 * - Stopping (disabling) audio recording if it is currently active
 *
 * @returns A callback function to invoke when the user's session expires.
 */
export function useHandleNeedsReLoginCallback() {
  const getUserType = useAtomCallback(useCallback((get) => get(userTypeAtom), []));
  const stopRecording = useStopRecordingCallback();

  return useCallback(() => {
    if (getUserType() === UserType.PROVIDER) {
      stopRecording({
        newRecordingState: AudioRecordingState.DISABLED,
        shouldBroadcastState: true,
      });
    }
  }, [getUserType, stopRecording]);
}
